import React, { useEffect, useState } from "react";
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonModal,
  IonRow,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { checkmarkDoneCircleOutline, warningOutline } from "ionicons/icons";
import { useSelector } from "react-redux";
import { selectCreatedCounter } from "../../../store/massiveDocumentCreate/selectors/selectCreatedCounter";
import { selectCreateStatus } from "../../../store/massiveDocumentCreate/selectors/selectCreateStatus";
import { selectSelectedUsers } from "../../../store/massiveDocumentCreate/selectors/selectSelectedUsers";
import { useParams } from "react-router-dom";


export const CreateStatus = () => {
  const selectedUsers = useSelector(selectSelectedUsers);
  const createStatus = useSelector(selectCreateStatus);
  const createdCounter = useSelector(selectCreatedCounter);
  const { userId }: { userId: string } = useParams();

  const [failedUsers, setFailedUsers] = useState<string[]>([])

  useEffect(() => {
    if (createStatus === 'fulfilled') {
      const data = localStorage.getItem('failedUsers')
      if (data) {
        setFailedUsers(JSON.parse(data))
        localStorage.removeItem('failedUsers')
      }
    }
  }, [createStatus])

  console.log({
    createStatus,
    createdCounter,
    total: selectedUsers.length,
  });
  return (
    <>
      <IonModal isOpen={["pending", "fulfilled"].includes(createStatus)} backdropDismiss={false}>
        <IonHeader translucent>
          <IonToolbar>
            <IonTitle>Creación de acuerdos</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <br />
          <br />
          <IonGrid style={{ height: "100%", width: "100%" }} class="ion-padding">
            <IonRow class="ion-align-items-baseline" style={{ height: "100%" }}>
              <IonCol size="12" class="ion-padding-top">
                {createStatus === "pending" && (
                  <>
                    <IonSpinner name="lines" />
                    <h3>
                      {createdCounter} de {selectedUsers.length} acuerdos creados correctamente
                    </h3>
                  </>
                )}
                {createStatus === "fulfilled" && selectedUsers.length - createdCounter === 0 && (
                  <>
                    <IonIcon
                      icon={checkmarkDoneCircleOutline}
                      size="large"
                      color="success"
                    ></IonIcon>
                    <h3>
                      {createdCounter} de {selectedUsers.length} acuerdos creados correctamente
                    </h3>
                  </>
                )}

                {createStatus === "fulfilled" && selectedUsers.length - createdCounter > 0 && (
                  <>
                    <IonIcon icon={warningOutline} size="large" color="warning"></IonIcon>
                    <h3>
                      {createdCounter} de {selectedUsers.length} acuerdos creados correctamente
                    </h3>
                  </>
                )}

                {failedUsers.length > 0 && (
                  <div>
                    <p><strong>No se pudo crear acuerdos para:</strong></p>
                    <ul>
                      {failedUsers.map((user, index) => (
                        <li key={index}>{user}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
        {createStatus === "fulfilled" && (
          <IonFooter>
            <IonToolbar color="light">
              <IonButtons slot="end">
                <IonButton routerLink={userId != undefined ? `/app/supervision/colaborador/${userId}`:"/app/rrhh/acuerdos"} color="primary" fill="solid">
                  Aceptar
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonFooter>
        )}
      </IonModal>
    </>
  );
};
